import { THEME } from "constants/types";

const initState = {
  theme: "light",
  globalTheme: "light"
}


const ThemeReducer = (state = initState, action) => {
  const { type, payload } = action;

  switch(type) {

    case THEME.SET_THEME:
      return {
        ...state,
        theme: payload,
      }

    case THEME.SET_GLOBAL_THEME:

      window.localStorage.setItem("theme", payload);
      let html = document.documentElement.classList;
      let body = document.body.classList;

      if(html) {
        html.remove('light');
        html.remove('dark');
        html.add(payload || 'light');
      }

      if(body) {
        body.remove('light');
        body.remove('dark');
        body.add(payload || 'light');
      }

      body.remove('notransition');
      return {
        ...state,
        globalTheme: payload,
      }

    default:
        return state
  }
}

export default ThemeReducer